<template>
  <div>
    <el-row>
      <!-- <h5>总金额：{{this.total_price}}</h5> -->
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="FLAG" label="退货类型" width="91" :filters="typeFilterData" :filter-method="typeFilter">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.FLAG === 0" type="success">{{ returnType[scope.row.FLAG] }}</el-tag>
              <el-tag v-else>{{ returnType[scope.row.FLAG] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="ORDER_ID" label="订单号" width="80"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" width="120"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" width="70"></el-table-column>
          <!-- <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="70"></el-table-column> -->
          <el-table-column prop="BATCH" label="批次" min-width="70"></el-table-column>
          <el-table-column prop="CODE" label="退货库位" min-width="70"></el-table-column>
          <!-- <el-table-column prop="PRODUCTION_DATE" label="生产日期" min-width="70"></el-table-column>
                    <el-table-column prop="EXPIRATION_DAY" label="保质期（天）" min-width="70"></el-table-column> -->
          <el-table-column prop="PRODUCT_COUNT" label="退货数量" min-width="45"></el-table-column>
          <el-table-column prop="RETURN_REASON" label="退货原因" min-width="45"></el-table-column>
          <!-- <el-table-column prop="PRODUCT_WORTH" label="剩余价值" min-width="45"></el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="showAddForm(scope.row)">上架</el-button>
              <el-button v-if="scope.row.FLAG === 0" size="small" type="text" @click="returnStock(scope.row)">退货</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <el-dialog title="选择上架库位" center :visible.sync="addFormVisible" width="350px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" size="small" class="el-form--label-justify">
        <el-form-item label="库位编码：" :label-width="formLabelWidth">
          <el-select v-model="addForm.LOCATION_CODE" :filter-method="positionFilter" filterable>
            <el-option v-for="item in positionList" :key="item.ID" :label="item.CODE" :value="item.CODE"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取 消</el-button>
        <el-button size="small" @click="addToStock()">重新上架</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryReturnStock, exportWarehouseFun, putBackOnStock, stockReturn,
  queryPosition,
} from '@/assets/api/warehouseManager';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '11211', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1121101: 0, 1121102: 0, 1121103: 0 }, // 功能ID 一旦规定不要轻易改动
      loading: false,
      exportFormVisible: false,
      exportForm: {},
      firstList: [],
      secondList: [],
      returnVisible: false,
      showStatus: 0,
      returnForm: {},
      count: 0,
      showAll: true,
      firstTypeList: [],
      TAB_CODE: '',
      total_price: 0,
      tableData: [],
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
      addForm: {},
      addFormVisible: false,
      formLabelWidth: '120px',
      putOnArr: [],
      checkedArray: [],
      returnType: {
        0: '采购退货',
        1: '销售退货',
      },
      positionList: [],
      positionListAll: [],
      typeFilterData: [
        { text: '采购退货', value: 0 },
        { text: '销售退货', value: 1 },
      ],
      importVisible: false,
      importForm: {},
      url: '',
      fileList: [],
    };
  },
  mounted() {
    this.queryBeforeFun();
    this.showStatus = 0;
    this.handleSearch();
    this.queryPostionLi();
  },
  computed: {
    // 上一次的搜索结果和条件
    SAVE_STOCKLIST() {
      return this.$store.state.SAVE_STOCKLIST;
    },
    POSITION_CONDITION() {
      return this.$store.state.POSITION_CONDITION;
    },
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    queryPostionLi() {
      if (this.POSITION_CONDITION.POSITIONLIST != null) {
        this.positionListAll = this.POSITION_CONDITION.POSITIONLIST;
        return;
      }
      queryPosition({ STATUS: 1 }).then((result) => {
        this.positionListAll = Object.freeze(result);
        // 将库位信息存储到vuex中
        this.$store.dispatch('SET_POSITION_CONDITION', {
          POSITIONLIST: result,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    positionFilter(query = '') {
      const arr = this.positionListAll.filter((item) => item.CODE.includes(query));
      if (arr.length > 50) {
        this.positionList = arr.slice(0, 50);
      } else {
        this.positionList = arr;
      }
    },
    // ---------------------------------------------导出
    exportOrder() {
      this.exportFormVisible = true;
    },
    submitExport() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            FIRST_LEVEL_CATALOG: this.exportForm.firstLevel,
            SECOND_LEVEL_CATALOG: this.exportForm.secondLevel,
          };
          exportWarehouseFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportFormVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    closeExport() {
      this.exportFormVisible = false;
      this.exportForm = {};
    },
    // ---------------------------显示隐藏库存为零
    showBlock() {
      if (this.showStatus !== 1) {
        this.showStatus = 1;
        this.getStorageList();
      } else {
        this.showStatus = 0;
        this.getStorageList();
      }
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.handleSearch();
    },
    // -----------------------------筛选功能
    handleSearch() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: this.showStatus,
      };
      this.loading = true;
      queryReturnStock(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.tableData = result[0].LIST.map((item, index) => Object.assign(item, { CXCOUNT: item.CXCount }, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    showAddForm(row) {
      this.addForm.PRODUCT_CODE = row.PRODUCT_CODE;
      this.addForm.PRODUCT_COUNT = row.PRODUCT_COUNT;
      this.addForm.BATCH = row.BATCH;
      this.addForm.RETURN_ID = row.RETURN_ID;
      this.addForm.ORDER_ID = row.ORDER_ID;
      this.addForm.PRODUCTION_DATE = row.PRODUCTION_DATE;
      this.addForm.FLAG = row.FLAG;
      this.addForm.LOCATION_CODE = row.CODE;
      this.addFormVisible = true;
    },
    addToStock() {
      const params = {
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
        PRODUCT_COUNT: this.addForm.PRODUCT_COUNT,
        BATCH: this.addForm.BATCH,
        RETURN_ID: this.addForm.RETURN_ID,
        ORDER_ID: this.addForm.ORDER_ID,
        LOCATION_CODE: this.addForm.LOCATION_CODE,
        PRODUCTION_DATE: this.addForm.PRODUCTION_DATE,
        FLAG: this.addForm.FLAG,
      };
      putBackOnStock(params).then((res) => {
        this.$message.show({ text: '重新上架成功', type: 'success' });
        this.addForm = {};
        this.addFormVisible = false;
        this.handleSearch();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange(e) {
      this.checkedArray = Object.assign([], e);
    },
    returnStock(row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        const details = {
          BATCH: row.BATCH,
          PRODUCT_CODE: row.PRODUCT_CODE,
          PRODUCT_COUNT: row.PRODUCT_COUNT,
          RETURN_REASON: row.RETURN_REASON,
          PRODUCTION_DATE: row.PRODUCTION_DATE,
          LOCATION_CODE: row.CODE,
        };
        const submitArr = [];
        submitArr.push(details);
        const params = {
          ORDER_ID: row.ORDER_ID,
          DETAILS: submitArr,
          RETURN_ID: row.RETURN_ID,
        };
        stockReturn(params).then((result) => {
          this.$message.show({ text: '退货成功', type: 'success' });
          this.handleSearch();
          document.body.style.cursor = 'default';
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          document.body.style.cursor = 'default';
        });
      }
    },
    typeFilter(value, row) {
      return row.FLAG === value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/returnStock.vue